import GameScreen from '../components/GameScreen';
import useViewportScale from '../hooks/useViewportScale';

function WaitingForPromptsScreen({ players, playerPromptProgress, promptsPerPlayer }) {
  const px = useViewportScale();

  return (
    <GameScreen
      backgroundVideo="/waiting-for-prompts.mp4"
      introSound="/Ok Poodles time to submit.m4a"
      title={'Submit your prompts!'}
      contentPosition="top"
      players={players}
      playerOpacityFn={(player) => {
        const progress = playerPromptProgress[player.name] || 0;
        return progress >= promptsPerPlayer ? 1 : 0.4;
      }}
      playerLayout="grid"
      playerSize={px(200)}
      playerAnimate
      playerPosition={{
        position: 'absolute',
        top: '25%',
        left: '5%',
        width: '50%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
      }}
    />
  );
}

export default WaitingForPromptsScreen;
